var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4876_229414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill stroke-same",
    d: "M1.1 0.749939H22.9C23.0933 0.749939 23.25 0.90664 23.25 1.09994V15.8999C23.25 16.0932 23.0933 16.2499 22.9 16.2499H1.1C0.9067 16.2499 0.75 16.0932 0.75 15.8999V1.09994C0.75 0.906639 0.906701 0.749939 1.1 0.749939Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M10 11.1805H13.6384V12.9997H10V11.1805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M12.7336 12.0962H10.9048V7.5434H10V5.7337H12.7336V12.0962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M10.9131 2.99994H12.7323V4.81916H10.9131V2.99994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17V23.7985H13.0127V17H11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 22H17V24.0734H7V22Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4876_229414"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoboard);
export default __webpack_public_path__ + "static/media/infoboard.197ab777.svg";
export { ForwardRef as ReactComponent };